import PropTypes from "prop-types";
import React from "react";

import { classNames } from "@swa-ui/string";

import styles from "./Shadow.module.scss";

/**
 * Shadow is a wrapper component that applies box-shadow or
 * drop-shadow effects to its children.
 */

export const Shadow = (props) => {
  const { children, className, level = "low", shadowType = "box" } = props;

  return (
    <div className={classNames(className, styles[`${level}-${shadowType}-shadow`])}>{children}</div>
  );
};

Shadow.displayName = "Shadow";

Shadow.propTypes = {
  /** Content that will be wrapped with the shadow effect */
  children: PropTypes.node,

  /**
   * Additional classes for positioning the component. Given classes may only position this component for layout
   * purposes, and cannot change how the component renders in any way.
   */
  className: PropTypes.string,

  /** Shadow intensity level - either 'low' or 'high' */
  level: PropTypes.oneOf(["low", "high"]),

  /** Type of shadow to apply - either 'box' or 'drop' */
  shadowType: PropTypes.oneOf(["box", "drop"]),
};
